import { Button, Drawer, useTranslation, ButtonWidth } from '@nextgen-web-framework/all';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, AppState } from '@nextgen-web-framework/core';
import { sendOtpWithChallengeIdSliceReq } from '@commerce-identity-webcomponents/sdk';
import VerifyCodeForm from '../../verify-code-form/VerifyCodeForm';
import OtpSentFeedback from '../otp-sent-feedback/OtpSentFeedback';
import { OtpVerificationProps } from '../types/propTypes';
import styles from './OtpVerification.module.scss';

const OtpVerification = ({
  challengeId,
  username,
  onClose,
  autoverify = true,
  showChangeCTA,
  onChangeCTA,
  showLabelForForgotPassword,
  usernameType,
}: OtpVerificationProps) => {
  const t = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { isVerified } = useSelector((state: AppState) => state.commerceIdentity.otpData);
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const sendOtpNotification = () => dispatch<any>(sendOtpWithChallengeIdSliceReq({ challengeId }));
  const header = t('identity.VerifyOtp.headline');

  const footer = !autoverify && (
    <Button
      title={isVerified ? t('identity.VerifyOtp.nextButton') : t('identity.VerifyOtp.verifyButton')}
      buttonWidth={ButtonWidth.FULL_WIDTH}
      onClick={isVerified ? onChangeCTA : sendOtpNotification}
    />
  );

  const getContent = () => (
    <>
      <OtpSentFeedback
        username={username}
        showChangeCTA={showChangeCTA}
        onChangeCTA={onChangeCTA}
        showLabelForForgotPassword={showLabelForForgotPassword}
        usernameType={usernameType}
      />
      <VerifyCodeForm sendOtpNotification={sendOtpNotification} autoverify={autoverify} modeValue={username} />
    </>
  );

  const drawerProps = {
    header,
    footer,
    children: getContent(),
    closeIcon: true,
    closeOnBackdropClick: false,
    onClose,
    bottomGap: 0,
    handleScroll: false, //To handle the drawer flicker
    className: `${styles['otp-drawer']}`,
  };

  return (
    <div data-testid="mlpv1-otp-verification" id="mlpv1-otp-verification">
      <Drawer {...drawerProps} />
    </div>
  );
};

export { OtpVerification };
